import fetch from "auth/FetchInterceptor";

export const OutletService = {};

OutletService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  district = null,
  state = null,
}) => {
  let apiUrl = "/v1/outlet?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Dname";
  else if (sort === "descend") apiUrl += "&order_by=%2Bname";
  if (searchText) apiUrl += "&name=" + searchText;
  if (district) {
    apiUrl += "&districts[]=" + district;
  }
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

OutletService.getCashReport = async (id) => {
  const apiUrl = `/v1/outlet/${id}/cash-report`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

OutletService.getByDistrict = async ({
  page,
  pageSize,
  searchText,
  districts,
}) => {
  let apiUrl = "/v1/outlet?page=" + page + "&per_page=" + pageSize;
  if (searchText) apiUrl += "&name=" + searchText;
  if (districts) {
    districts.forEach((value) => {
      const district = "&districts[]=" + value;
      apiUrl = apiUrl + district;
    });
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

OutletService.getById = async (id) => {
  const apiUrl = `/v1/outlet/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

OutletService.createOutlet = async (data) => {
  const apiUrl = `/v1/outlet`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

OutletService.updateOutlet = async (data) => {
  const apiUrl = `/v1/outlet/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

OutletService.deleteOutlet = async (id, confirm = false) => {
  let apiUrl = `/v1/outlet/${id}`;
  if (confirm) apiUrl = `/v1/outlet/${id}?confirmed`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default OutletService;
